
export default function
($route, $routeParams, $location,
  Application, AuthenticationService,
  ContentEditor, ContentService,
  RecentContentService,
  WorkspaceService) {
  var workspaceName;

  AuthenticationService.getCurrentUser()
    .then(function (user) {
      workspaceName = user.userId + '-workspace';
      return ContentService.getContentVersion({
        version: $route.current.params.versionId,
        fullTypeInfo: true
      });
    })
    .then(function (versionResult) {
      return WorkspaceService.updateContent({
        alias: atex.aceui.ObjectUtils.getByPath(versionResult, 'content/system/id'),
        origin: $routeParams.currentRevision,
        workspace: workspaceName,
        updateMode: 'replace',
        fullTypeInfo: true,
        content: {
          aspects: versionResult.content.aspects,
          system: versionResult.content.system
        }
      });
    })
    .then(function (updateResult) {
      $location.search ({});
      let alias = atex.aceui.ObjectUtils.getByPath(updateResult, 'content/system/id');
      RecentContentService.addContent (alias, false, true);
      ContentEditor.editContent(alias);
    })
    .catch(function (error) {
      console.log('ERROR: ', error);
      Application.currentErrorInfo = { error: error };
      $location.path('/error');
      $location.replace();
    });
}